<template>
  <div id="promo">
    <nav-common></nav-common>
    <div class="promo-content">
      <div class="tips">合作银行</div>
      <ul class="list">
        <a v-for="bank of banks" @click="downloadQr(bank,$event)"><img v-lazy="bank" alt=""></a>
      </ul>
      <div class="tips">合作机构</div>
      <ul class="list">
        <a v-for="loan of loans" @click="downloadQr(loan,$event)"><img v-lazy="loan" alt=""></a>
      </ul>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import NavCommon from '@/components/navtop/navcommon'

export default {
  name: 'Promo',
  data () {
    return {
      banks: {},
      loans: {}
    }
  },
  created() {
    this.getQrList();
  },
  methods: {
    getQrList() {
      var _this = this;
      _this.$http({
        method: 'get',
        url: _this.$api + '/service/agent/spread/qr_list'
      }).then((res) => {
        if(res.data.code == 200) {
          _this.banks = res.data.data.banks;
          _this.loans = res.data.data.loans;
        }
      })
    },
    downloadQr(url,e) {
      var el = e.target.parentNode;
      var _this = this;
      var imgUrl = url;
      if(_this.browserIsIe()) {
        if (imgUrl.indexOf('data:image') > -1) {
            var blob = base64Img2Blob(imgUrl);
            window.navigator.msSaveBlob(blob, "下载.png");
        } else {
            DownLoadReportIMG(imgUrl);
        }
      } else {
        el.setAttribute('download',imgUrl);
        el.setAttribute('href',imgUrl);
      }
    },
    base64Img2Blob(code) {
      var parts = code.split(';base64,');
      var contentType = parts[0].split(':')[1];
      var raw = window.atob(parts[1]);
      var rawLength = raw.length;
      var uInt8Array = new Uint8Array(rawLength);
      for (var i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], {type: contentType});
    },
    DownLoadReportIMG(imgPathURL) {
        // 如果隐藏IFRAME不存在，则添加
        if (!document.getElementById("IframeReportImg"))
            $('<iframe style="display:none;" id="IframeReportImg" name="IframeReportImg" onload="DoSaveAsIMG();" width="0" height="0" src="about:blank"></iframe>').appendTo("body");
        if (document.all.IframeReportImg.src != imgPathURL) {
            // 加载图片
            document.all.IframeReportImg.src = imgPathURL;
        }
        else {
            DoSaveAsIMG();
        }
    },
    DoSaveAsIMG() {
        if (document.all.IframeReportImg.src != "about:blank")
            window.frames["IframeReportImg"].document.execCommand("SaveAs");
    },
    browserIsIe() {
        if (!!window.ActiveXObject || "ActiveXObject" in window) {
            return true;
        }
        else {
            return false;
        }
    }
  },
  components: {
    NavCommon
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  #promo
    .promo-content
      position relative
      margin 20px
      padding 60px 40px 20px 40px
      background #f8f8f8
      box-shadow 3px 3px 3px #f5f5f5 inset
    .tips
      font-size: 20px
      margin: 10px 0
    .list
      a
        display: inline-block
        width: 200px
        margin: 10px
        img
          width: 100%
</style>



// WEBPACK FOOTER //
// src/components/promo/promo.vue